import { useNavigate } from 'react-router-dom';

import HomeSelection from '../../components/home/HomeSelection';

export default function HomeContainer() {
    const navigate = useNavigate();

    const handleSelectChat = () => navigate('/chat');
    const handleSelectIdea = () => navigate('/idea');

    return (
        <HomeSelection
            onSelectChat={handleSelectChat}
            onSelectIdea={handleSelectIdea}
        />
    );
}
